import { type DesignElementBase } from "..";
import { createIcon } from "../design-element-utils";

const designElement: DesignElementBase = {
  tags: ["organic-search", "organicsearch", "organic search"],
  iconColor: "#C825A8", // venus
  getIcon(options) {
    return createIcon(
      `
        <path
          d="M14.1875 11.3125C14.1875 10.1992 13.582 9.18359 12.625 8.61719C11.6484 8.05078 10.457 8.05078 9.5 8.61719C8.52344 9.18359 7.9375 10.1992 7.9375 11.3125C7.9375 12.4453 8.52344 13.4609 9.5 14.0273C10.457 14.5938 11.6484 14.5938 12.625 14.0273C13.582 13.4609 14.1875 12.4453 14.1875 11.3125ZM13.582 14.5156C12.8789 15.0625 12 15.375 11.0625 15.375C8.81641 15.375 7 13.5586 7 11.3125C7 9.08594 8.81641 7.25 11.0625 7.25C13.2891 7.25 15.125 9.08594 15.125 11.3125C15.125 12.2695 14.793 13.1484 14.2461 13.8516L16.668 16.2734L17 16.6055L16.3359 17.25L16.0039 16.918L13.582 14.4961V14.5156Z"
          fill="#C825A8" />
      `,
      "#F9E9F6", // venus-2
      options?.borderColor || "#E0E2E6",
      options?.size || "24",
    );
  },
};

export default designElement;
